import { render, staticRenderFns } from "./TipoCliente.vue?vue&type=template&id=56a7398a&scoped=true&"
import script from "./TipoCliente.vue?vue&type=script&lang=ts&"
export * from "./TipoCliente.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a7398a",
  null
  
)

export default component.exports